function isProfessionalQualification(object) {
    return 'professional_qualification_attributes' in object;
}
function isAgencyQualification(object) {
    return 'agency_qualification_attributes' in object;
}
/**
 * A class that provides helper methods to simplify the display of a ProfessionalQualification or AgencyQualification
 */
export class Credential {
    credential;
    attributes;
    constructor(credential) {
        if (!credential.professional_qualification_attributes &&
            !credential.agency_qualification_attributes) {
            throw new Error('Credential must be instantiated with associated <professional or agency>_qualification_attributes');
        }
        if (isProfessionalQualification(credential)) {
            if (credential.professional_qualification_attributes.some((pqa) => !pqa.qualification_attribute)) {
                throw new Error('Credential must be instantiated with associated qualification_attributes');
            }
            this.attributes = credential.professional_qualification_attributes;
        }
        if (isAgencyQualification(credential)) {
            if (credential.agency_qualification_attributes.some((aqa) => !aqa.qualification_attribute)) {
                throw new Error('Credential must be instantiated with associated qualification_attributes');
            }
            this.attributes = credential.agency_qualification_attributes;
        }
        this.credential = credential;
    }
    /**
     * The expiration date of the PQ, if present
     * @returns value of the expiration date pqa of the pq
     */
    get expirationDate() {
        return (this.attributes?.find((attr) => attr?.qualification_attribute?.field_type === 'expiration_date')?.value ?? null);
    }
    /**
     * The license number(s) of the PQ, if present
     * @returns array of the name and value of the license number pqa's for the pq
     */
    get licenseNumbers() {
        return (this.attributes
            ?.filter((attr) => attr?.qualification_attribute?.field_type === 'license_number')
            ?.map((pqa) => ({ fieldName: pqa.qualification_attribute?.name, value: pqa.value })) ?? []);
    }
    /**
     * The state name of the PQ, if present
     * @returns string state abbreviation of the state pqa for the pq
     */
    get state() {
        return (this.attributes?.find((attr) => attr?.qualification_attribute?.field_type === 'state')
            ?.state ?? null);
    }
    /**
     * The state id of the PQ, if present
     * @returns number state id of the state pqa for the pq
     */
    get stateId() {
        return (this.attributes?.find((attr) => attr?.qualification_attribute?.field_type === 'state')
            ?.value ?? null);
    }
    /**
     * The src of the imageFront pqa, if present
     * @returns src of the imageFront pqa for the pq
     */
    get imageFrontSrc() {
        return (this.attributes?.find((attr) => attr?.qualification_attribute?.field_type === 'image_front')
            ?.value ?? null);
    }
    /**
     * The src of the imageBack pqa, if present
     * @returns src of the imageBack pqa for the pq
     */
    get imageBackSrc() {
        return (this.attributes?.find((attr) => attr?.qualification_attribute?.field_type === 'image_back')
            ?.value ?? null);
    }
}
